import { Box } from "@mui/material";
import React, { useState } from "react";
import { DEFAULT_MEAL_IMAGE } from "../../model/constants";

type Props = {
  src: string;
  alt: string;
  height: number;
};

/** A food/recipe photo that falls back to the shared placeholder when the CDN image fails. */
const MealImage = ({ src, alt, height }: Props) => {
  const [failed, setFailed] = useState(false);

  return (
    <Box
      component="img"
      src={failed ? DEFAULT_MEAL_IMAGE : src}
      alt={alt}
      onError={() => setFailed(true)}
      sx={styles.image(height)}
    />
  );
};

export default MealImage;

const styles = {
  image: (height: number) => ({
    display: "block",
    width: "100%",
    height: `${height}px`,
    objectFit: "cover" as "cover",
  }),
};
